import client from "api/client";

import type { PartnerCms, PartnerConfigInfo, PartnerConfigUpdate, PartnerPaywall, PartnerStatus } from "api/models/partner";


const base = "/partner";
const partner = {
	getAllCms: () => client.get<PartnerCms[]>(base + "/cms"),
	getPaywalls: (id: string) => client.get<PartnerPaywall[]>(base + `/cms/${id}/paywalls`),
	status: () => client.get<PartnerStatus>(base + "/status")
};

const configBase = base + "/config";
const config = {
	get: (partnerId: number) => client.get<PartnerConfigInfo>(configBase + `/${partnerId}`),
	update: (partnerId: number, payload: PartnerConfigUpdate) => client.put<PartnerConfigInfo>(configBase + `/${partnerId}`, payload)
};

export default { ...partner, config };